import { Alert } from './alert';
import { lang } from 'lang';

export const Confirm = (title, onYes, yes_title, no_title) => {
  if (typeof title === 'function') {
    onYes = title;
    title = lang.ALERT_DEFAULT_TEXT;
  }
  Alert.alert(title, null, [{ text: yes_title || lang.OK, onPress: onYes }, { text: no_title || lang.CANCEL }]);
};



// WEBPACK FOOTER //
// ./src/components/core/confirm_box.js